import { Locale } from 'modules/i18n';

export const docsMenuItemTranslation = {
  [Locale.en]: {
    docs: 'Docs',
  },
};
